if (!customElements.get('announcement-countdown')) {
  class AnnouncementCountdown extends HTMLElement {
    connectedCallback() {
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.endTimestamp = Number(this.dataset.endTimestamp);

      if (!this.daysEl || Number.isNaN(this.endTimestamp)) {
        this.hidden = true;
        return;
      }

      this.tick();
      this.intervalId = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
      }
    }

    pad(value) {
      return String(value).padStart(2, '0');
    }

    tick() {
      const remainingMs = this.endTimestamp * 1000 - Date.now();

      if (remainingMs <= 0) {
        this.daysEl.textContent = '00';
        this.hoursEl.textContent = '00';
        this.minutesEl.textContent = '00';
        this.secondsEl.textContent = '00';
        if (this.intervalId) {
          window.clearInterval(this.intervalId);
        }
        return;
      }

      const totalSeconds = Math.floor(remainingMs / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.daysEl.textContent = this.pad(days);
      this.hoursEl.textContent = this.pad(hours);
      this.minutesEl.textContent = this.pad(minutes);
      this.secondsEl.textContent = this.pad(seconds);
    }
  }

  customElements.define('announcement-countdown', AnnouncementCountdown);
}
